import { useCallback } from 'react'
import { setSchedulerColumns } from '../../../../../atoms/columns'

export function useResetColumnInfo() {
  return useCallback(() => {
    setSchedulerColumns('reset')
  }, [])
}
